import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { ServiceResponse } from '../model/service'

import { get, post, put, _delete } from './abstract.service'

class ServiceProvider {
  httpConfig: AxiosRequestConfig = {}
  http: AxiosInstance = axios.create(this.httpConfig)
  esApiHttpConfig: AxiosRequestConfig = {}
  esApiHttp: AxiosInstance = axios.create(this.esApiHttpConfig)
  addaJetApiHttpConfig: AxiosRequestConfig = {}
  addaJetHttp: AxiosInstance = axios.create(this.addaJetApiHttpConfig)

  setContentApiPath(value: string) {
    this.httpConfig.baseURL = value
    this.recreateHttp()
  }

  setElasticsearchApiPath(value: string) {
    this.esApiHttpConfig.baseURL = value
    this.esApiHttp = axios.create(this.esApiHttpConfig)
  }

  setAddaJetApiPath(value: string) {
    this.addaJetApiHttpConfig.baseURL = value
    this.addaJetHttp = axios.create(this.addaJetApiHttpConfig)
  }

  recreateHttp() {
    this.http = axios.create(this.httpConfig)
  }

  get = get
  post = post
  put = put
  delete = _delete
}

export function extractData <T> (response: ServiceResponse<T>): T {
  // @ts-ignore
  return response.data.data || response.data
}

// todo
export function extractElasticSearchData <T> (response: ServiceResponse<T>): T {
  // @ts-ignore
  return response.data.hits || response.data // TODO
}

export default new ServiceProvider()
